import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { TFeature } from '@partners/settings';
import { Observable } from 'rxjs';
import { IRootState, RootActions } from '../store';

@Injectable({
  providedIn: 'root'
})
export class RootStore {
  private _store = inject(Store<IRootState>);

  constructor() {}

  dispatchResetState() {
    this._store.dispatch(RootActions.reset());
  }

  selectDomain$<S>(domain: TFeature): Observable<S> {
    // createFeatureSelector<S>(domain);
    return this._store.select(domain);
  }
}
